import styled from 'styled-components'
import copy from 'copy.json'

export default function Footer() {
  return (
    <StyledFooter className="dark">
      <div>&copy; {copy.layout.footer.copy_rights}</div>
    </StyledFooter>
  )
}

const StyledFooter = styled.footer`
  flex: none;
  display: flex;
  justify-content: center;
  padding: 32px max(8px, calc((100% - 1312px) / 2));
  background-image: linear-gradient(
    rgba(39, 67, 47, 0.3),
    rgba(39, 67, 47, 0.3),
    rgba(39, 67, 47, 0.7),
    #27432f
  );
`
